import { defaultTheme, flattenPalette } from '../system';
import { objectToCSSProperties } from '../utils';
export function getThemeDataAttribute(themeId) {
  if (themeId) {
    return "data-tapestry-react-theme-provider-" + themeId;
  } else {
    return 'data-tapestry-react-theme-provider';
  }
}

var getRootStyles = function getRootStyles(id, styles) {
  var styleString = Object.keys(styles).map(function (key) {
    return key + ": " + styles[key];
  }).join('; ');
  return "[" + getThemeDataAttribute(id) + "] { " + styleString + " }";
};

export var setRootStyles = function setRootStyles(themeId, styles) {
  ensureStyleElement(themeId);
  var styleElement = document.getElementById("tapestry-react-style-" + themeId);
  var sheet = styleElement.sheet;
  var styleString = getRootStyles(themeId, styles);
  sheet.deleteRule(0);
  sheet.insertRule(styleString, 0);
};
export var defaultColorProperties = objectToCSSProperties('colors', flattenPalette(defaultTheme.colors));
export var styleReset = ("\n" + getRootStyles(null, defaultColorProperties) + "\n\n.tapestry-react-reset {\n  appearance: none;\n  background-color: transparent;\n  border-width: 0px;\n  border-style: solid;\n  border-color: transparent;\n  box-sizing: border-box;\n  color: inherit;\n  box-sizing: border-box;\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: auto;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';\n  font-weight: 400;\n  margin-top: 0;\n  margin-right: 0;\n  margin-bottom: 0;\n  margin-left: 0;\n  min-width: 0px;\n  min-height: 0px;\n  padding-top: 0;\n  padding-right: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  text-decoration: none;\n}\n\n.tapestry-react-reset::-moz-focus-inner {\n  padding-top: 0;\n  padding-right: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  border: none;\n}\n\n.tapestry-react-reset:focus:not(.focus-visible) {\n  outline: 0px;\n}\n" // minify string
).replace(/\n/g, '').replace(/\s\s+/g, ' '); // we use our own global style implementation in place of Emotion Global
// so we can have more control over when styles are injected since multiple
// Providers can be used on a page

function ensureStyleElement(themeId) {
  if (typeof window !== 'undefined' && !document.getElementById("tapestry-react-style-" + themeId)) {
    var styleElement = document.createElement('style');
    styleElement.id = "tapestry-react-style-" + themeId;
    styleElement.innerHTML = styleReset;
    document.head.insertAdjacentElement('afterbegin', styleElement);
  }
}